import Vue from 'vue';
import { guid } from '@/mixins/guid';
import { modals } from '@/mixins/modal';
import ForgetDeviceModal from './forget-device-modal';
import LogoutAllModal from './logout-all-devices';

export default Vue.component('security-devices', {
  template: require('./template.html'),
  name: 'security-devices',
  mixins: [guid, modals],
  components: {
    ForgetDeviceModal,
    LogoutAllModal,
  },
  data() {
    return {
      loading: false,
      devices: [],
      deviceErrors: false,
      activeDevice: null,
      activeIndex: null,
      modals: {
        forgetDevice: false,
        logoutAll: false,
      },
    };
  },
  mounted() {
    this.getDevices();
    // used for the modal mixin
    this.cls = '.adminUi-modalOverlay';
  },
  methods: {
    async getDevices() {
      this.loading = true;
      this.deviceErrors = false;
      try {
        this.devices = await this._SEND([{
          name: 'getUserDevices',
          payload: {
            alerts: this.account.alerts,
          },
        }]);
      } catch (e) {
        this.$log.error(e.message || e);
        this.deviceErrors = e.message || e;
        await this._reportError({
          error: e,
          fn: 'getDevices',
        });
      } finally {
        this.loading = false;
      }
    },
    removeDevice(index) {
      this.devices.splice(index, 1);
    },
    formatTime(date) {
      return this._zoneFormat({ date, format: 'MM/DD/YYYY h:mm:ss a' });
    },
    toggleModal(type, c) {
      this.modals[type] = !this.modals[type];
      const content = !c ? this.$refs[type] : this.$refs[type].$el;
      if (this.modals[type]) {
        this.modelMoveOut(content);
      } else {
        this.modalMoveIn(content);
      }
    },
    setActive(device, index) {
      this.activeDevice = device;
      this.activeIndex = index;
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/admin/account/security/devices/index.js